import {
  CreateGlossaryDto,
  GlossaryEntryDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_GLOSSARY } from "../domain";

import { glossaryApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_GLOSSARY = "CREATE_GLOSSARY";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const createGlossary = async (
  req: CreateGlossaryDto,
): Promise<CreateGlossaryDto> => {
  const response = await glossaryApi.glossaryControllerCreateGlossaryTerm(req);

  return response.data as GlossaryEntryDto;
};

export const useCreateGlossaryTerm = (
  user: UserProfileDto | null,
): {
  createGlossary: UseMutateFunction<CreateGlossaryDto, Error, CreateGlossaryDto>;
  createGlossaryEnabled: boolean;
  isSuccessCreateGlossary: boolean;
  isPendingCreateGlossary: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_GLOSSARY, ACTION_CREATE_GLOSSARY],
    mutationFn: enabled ? createGlossary : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_GLOSSARY] });
    },
  });

  return {
    createGlossary: mutate,
    createGlossaryEnabled: enabled,
    isSuccessCreateGlossary: isSuccess,
    isPendingCreateGlossary: isPending,
  };
};
